const AUTH_CHANNEL_NAME = "bevan-auth";

// "expired" (default) is an involuntary logout - a 401 on an authenticated
// request - worth telling the user about. "manual" is them clicking Sign Out
// themselves, which every other open tab should also drop to anonymous for,
// but silently - they already know they logged out.
export const publishAuthLogout = (reason = "expired") => {
    if (typeof BroadcastChannel === "undefined") {
        return;
    }

    const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
    channel.postMessage({ type: "logout", reason });
    channel.close();
};

export const subscribeToAuthLogout = (onLogout) => {
    if (typeof BroadcastChannel === "undefined") {
        return () => {};
    }

    const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
    const handleMessage = ({ data }) => {
        if (data?.type === "logout") {
            onLogout(data.reason);
        }
    };

    channel.addEventListener("message", handleMessage);
    return () => {
        channel.removeEventListener("message", handleMessage);
        channel.close();
    };
};
